<template>
  <v-container fluid class="district-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">District Information</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">Create District</p>
                        <v-text-field
                          class="mb-4"
                          v-model="add_district.districtcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="District Code"
                          persistent-hint
                          single-line hint="Enter the district Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="add_district.districtname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="District Name"
                          persistent-hint
                          single-line hint="Enter the district name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="add_district.districtinfo"
                          outlined
                          dense
                          placeholder="Info Text"
                          persistent-hint
                          single-line hint="Enter the info text">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items=districttypes
                          v-model="add_district.districttype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the district type">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="regions.map(x => {
                            return {text: x.regionname, value: x._id};
                          })"
                          v-model="add_district.regionid"
                          outlined
                          dense
                          placeholder="Region"
                          persistent-hint
                          single-line hint="Please choose the region">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="townships.filter(x=>x.regionid==add_district.regionid).map(x => {
                            return {text: x.townshipname, value: x._id};
                          })"
                          v-model="add_district.townshipid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Township"
                          persistent-hint
                          single-line hint="Please choose the township">
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/district/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertDistrict()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      regionid: null,
      add_district: {},
      districttypes: ['District', 'Neighborhood', 'Commune'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  methods: {
    ...mapActions('District', ['insertDistrictRequest','getDistrictsRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('Township', ['getTownshipsRequest']),
    checkError(){
      if(!this.add_district.districtcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.add_district.districtname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.add_district.districttype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.add_district.townshipid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertDistrict() {
      if(!this.checkError()) return;
      await this.insertDistrictRequest(this.add_district);
      router.push('/district/list');
    },
  },
  computed: {
    ...mapState('District', ['isReceiving']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
  },
  async created () {
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
  },

}
</script>

<style src="./Add.scss" lang="scss"></style>
